import { useNavigate } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { XCircle, ArrowLeft, RotateCw } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function PaymentCancel() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white">
      <Navbar />

      <div className="pt-32 pb-20 px-4 md:px-8">
        <div className="max-w-lg mx-auto text-center space-y-6">
          <div className="w-20 h-20 mx-auto rounded-full bg-yellow-500/10 flex items-center justify-center">
            <XCircle className="w-12 h-12 text-yellow-400" />
          </div>

          <h1 className="text-3xl font-bold">Payment Cancelled</h1>

          <p className="text-[#A1A1AA] text-lg">
            Your payment was cancelled. No charges were made.
          </p>

          <p className="text-sm text-[#71717A]">
            Changed your mind? You can always come back and subscribe later.
          </p>

          <div className="flex gap-4 justify-center pt-4">
            <Button
              onClick={() => navigate("/")}
              className="bg-[#1C1C1E] hover:bg-[#27272A] text-white"
              data-testid="back-home-btn"
            >
              <ArrowLeft className="mr-2 w-4 h-4" />
              Back Home
            </Button>
            <Button
              onClick={() => navigate("/pricing")}
              className="bg-[#00E676] hover:bg-[#00C853] text-black"
              data-testid="retry-payment-btn"
            >
              <RotateCw className="mr-2 w-4 h-4" />
              Try Again
            </Button>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}
